import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FinancialDashboardResponse } from '../models/financial-results';

@Injectable({
    providedIn: 'root',
})
export class FinancialService {
    constructor(private http: HttpClient) { }

    getFinancialResults(params?: { since?: string; until?: string }): Observable<FinancialDashboardResponse> {
        let httpParams = new HttpParams();

        if (params?.since) {
            httpParams = httpParams.set('since', params.since);
        }

        if (params?.until) {
            httpParams = httpParams.set('until', params.until);
        }

        return this.http.get<FinancialDashboardResponse>(
            `${environment.apiUrl}/admin/financial/summary/`,
            { params: httpParams }
        );
    }
}
